/* eslint-env browser */

import isObject from 'lodash/isObject';
import { deviceType } from './utils';

function supportsLocalStorage() {
  try {
    var _window = window,
        localStorage = _window.localStorage;

    localStorage.setItem('pulse4test', 'check');
    localStorage.removeItem('pulse4test');
    return true;
  } catch (e) {
    return false;
  }
}

function getViewportDimensions() {
  var viewportwidth = void 0;
  var viewportheight = void 0;
  var _window2 = window,
      document = _window2.document;


  if (typeof window.innerWidth !== 'undefined') {
    viewportwidth = window.innerWidth;
    viewportheight = window.innerHeight;
  } else if (typeof document.documentElement.clientWidth !== 'undefined' && document.documentElement.clientWidth !== 0) {
    viewportwidth = document.documentElement.clientWidth;
    viewportheight = document.documentElement.clientHeight;
  } else {
    viewportwidth = document.getElementsByTagName('body')[0].clientWidth;
    viewportheight = document.getElementsByTagName('body')[0].clientHeight;
  }
  return viewportwidth + 'x' + viewportheight;
}

export default function () {
  if (!isObject(window)) {
    return {};
  }
  var _window3 = window,
      navigator = _window3.navigator,
      screen = _window3.screen;


  return {
    acceptLanguage: navigator.userLanguage || navigator.language,
    screenSize: screen.width + 'x' + screen.height,
    userAgent: navigator.userAgent,
    deviceType: deviceType(window.navigator.userAgent),
    viewportSize: getViewportDimensions(),
    localStorageEnabled: supportsLocalStorage()
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spt-tracking/pulse-event-builders/dist/ejs/device-defaults-browser.js
// module id = 1184
// module chunks = 0